/* 
  故障工单 
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>综合工单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 状态 -->

    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      class="tabs_style"
    >
      <el-tab-pane label="当前工单" name="first">
        <div style="width: 1500px; height: 80px">
          <el-form :inline="true" :model="formInline">
            <el-form-item label="工单编号:">
              <el-input
                size="small"
                v-model="formInline.work_number"
                placeholder="输入工单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单标题:">
              <el-input
                size="small"
                v-model="formInline.work_title"
                placeholder="输入工单标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="处理人名称:">
              <el-input
                size="small"
                v-model="formInline.handler"
                placeholder="输入处理人名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="search"
                >搜索</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="addFormVisible = true"
                >创建工单</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 查询 -->

        <el-table
          size="small"
          :data="listData"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_title"
            width="200"
            label="标题"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_lable"
            width="200"
            label="标签"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_number"
            width="150"
            label="工单编号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="relation"
            width="150"
            label="关联"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="handler"
            width="150"
            label="处理人"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="handler_phone"
            width="150"
            label="处理人电话"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="problem_dascribe"
            width="400"
            label="问题描述"
          >
          </el-table-column>
          <el-table-column align="center" prop="state" width="150" label="状态">
            <el-tag type="danger">未处理</el-tag>
          </el-table-column>
          <el-table-column
            align="center"
            prop="submit_time"
            width="250"
            label="提交时间"
          ></el-table-column>

          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="200"
          >
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="dialogFormVisible = true"
            ></el-button>
            <el-button size="mini" type="warning" round>撤销</el-button>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </el-tab-pane>

      <el-tab-pane label="历史工单" name="second">
        <div style="width: 1500px; height: 80px">
          <el-form :inline="true" :model="formList">
            <el-form-item label="工单编号:">
              <el-input
                size="small"
                v-model="formList.work_number"
                placeholder="输入工单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单标题:">
              <el-input
                size="small"
                v-model="formList.work_title"
                placeholder="输入工单标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="处理人名称:">
              <el-input
                size="small"
                v-model="formList.handler"
                placeholder="输入处理人名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <!-- 列表 -->
        <el-table
          size="small"
          :data="tableData"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_title"
            width="200"
            label="标题"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_lable"
            width="200"
            label="标签"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_number"
            width="150"
            label="工单编号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="relation"
            width="150"
            label="关联"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="handler"
            width="150"
            label="处理人"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="handler_phone"
            width="150"
            label="处理人电话"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="problem_dascribe"
            width="400"
            label="问题描述"
          >
          </el-table-column>
          <el-table-column align="center" prop="state" width="250" label="状态">
          </el-table-column>
          <el-table-column
            align="center"
            prop="submit_time"
            width="250"
            label="提交时间"
            fixed="right"
          >
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_parm.currentPage"
          background
          :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="page_parm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page_parm.total"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 创建工单 -->
    <el-dialog
      title="工单信息"
      :visible.sync="addFormVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form :model="addwork" :rules="rules">
          <el-form-item label="标题" prop="work_title" label-width="120px">
            <el-input
              size="small"
              v-model="addwork.work_title"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="标签" prop="work_lable" label-width="120px">
            <el-input
              size="small"
              v-model="addwork.work_lable"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="工单编号" prop="work_number" label-width="120px">
            <el-input
              size="small"
              v-model="addwork.work_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="关联" label-width="120px">
            <el-input
              size="small"
              v-model="addwork.relation"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="处理人" prop="handler" label-width="120px">
            <el-select
              clearable
              v-model="value"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in operationer"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="问题描述"
            prop="problem_dascribe"
            label-width="120px"
          >
            <el-input
              size="small"
              v-model="addwork.problem_dascribe"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="提交时间" prop="submit_time" label-width="120px">
            <el-input
              size="small"
              v-model="addwork.submit_time"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left: 10%">
          <el-button size="mini" type="primary" @click="submitForm('addwork')"
            >确 定</el-button
          >
          <el-button size="mini" @click="addFormVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
      title="编辑综合工单"
      :visible.sync="dialogFormVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form :model="form">
          <el-form-item label="问题描述" label-width="120px">
            <el-input
              size="small"
              type="textarea"
              v-model="form.problem_dascribe"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left: 10%">
          <el-button
            size="mini"
            type="primary"
            @click="dialogFormVisible = false"
            >确 定</el-button
          >
          <el-button size="mini" @click="dialogFormVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      input: "",
      dialogVisible: false,
      dialogFormVisible: false,
      show: false,
      addFormVisible: false,
      //  showmaplist:false,
      // car_position:"不走了",
      activeName: "first",
      now_state: "待处理",
      listData: [
        {
          id: "01",
          work_title: "20160502",
          work_lable: "车辆1;车辆2;车辆三;",
          work_number: "AA-sds123456",
          relation: "暂不开发",
          handler: "处理人",
          handler_phone: "12451245789",
          problem_dascribe: "问题描述",
          submit_time: "2022-02-01",
          remarks: "状态",
        },
        {
          id: "01",
          work_title: "20160502",
          work_lable: "车辆1;车辆2;车辆三;",
          work_number: "AA-123456",
          relation: "暂不开发",
          handler: "处理人",
          handler_phone: "12451245789",
          problem_dascribe: "问题描述",
          submit_time: "2022-02-01",
          remarks: "状态",
        },
      ],
      tableData: [
        {
          id: "01",
          work_title: "20160502",
          work_lable: "车辆1;车辆2;车辆三;",
          work_number: "AA-456",
          relation: "暂不开发",
          handler: "处理人",
          handler_phone: "12451245789",
          problem_dascribe: "问题描述",
          submit_time: "2022-02-01",
          remarks: "状态",
        },
      ],
      options: [
        {
          value: "选项1",
          label: "kk",
        },
        {
          value: "选项2",
          label: "QQ",
        },
      ],
      value: "",
      //添加选择运维人员
      operationer: [
        {
          value: "选项1",
          label: "KK",
        },
        {
          value: "选项2",
          label: "QQ",
        },
      ],
      value: "",
      form: {
        problem_dascribe: "",
      },
      formInline: {
        work_number: "",
        work_title: "",
        handler: "",
      },

      formList: {
        work_number: "",
        work_title: "",
        handler: "",
      },

      addwork: {
        work_title: "",
        work_lable: "",
        work_number: "",
        relation: "",
        handler: "",
        handler_phone: "",
        problem_dascribe: "",
        submit_time: "",
      },
      rules: {
        work_title: [
          { required: true, message: "请输入工单标题", trigger: "blur" },
        ],
        work_lable: [
          { required: true, message: "请输入工单标签", trigger: "blur" },
        ],
        work_number: [
          { required: true, message: "请输入工单编号", trigger: "blur" },
        ],
        // relation: [
        //   { type: 'string', required: true, message: '请输入关联', trigger: 'blur' }
        // ],
        handler: [
          { required: true, message: "请选择处理人员", trigger: "change" },
        ],
        problem_dascribe: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
        submit_time: [
          { required: true, message: "请输入提交时间", trigger: "blur" },
        ],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 5,
        total: 10,
      },
      page_parm: {
        currentPage: 1,
        pageSize: 5,
        total: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  methods: {
    //表单提交
    submitForm(addwork) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("请输入正确的信息");
          return false;
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    searchCar() {
      this.importInline.page = 1;
      this.importInline.limit = 10;
      this.getimport();
    },
    // 地图
    showmap() {
      this.show = !this.show;
      AMapLoader.load({
        key: "e77392d71f73ed7450b72a5bb42e806b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: "", // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // var center_path = result.locations;
        conmap = new AMap.Map("container", {
          //设置地图容器id
          viewMode: "3D", //是否为3D地图模式
          zoom: 15, //初始化地图级别
          center: [116.397428, 39.90923], //初始化地图中心点位置
          position: new AMap.LngLat(116.39, 39.9), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: "北京",
        });
        map.add(marker);
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style>
.tabs_style {
  margin-top: 30px;
  width: 100% !important;
}
.user-search {
  width: 100%;
  height: 80px;
}
.addmap {
  height: 500px;
}
#container {
  width: 100%;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/worksheet_mn/zh_work.vue